import { MatSnackBarConfig } from '@angular/material/snack-bar';

export enum SnackbarType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  NOTIFICATION = 'notification'
}

export enum SnackbarPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
  TOP_LEFT = 'top-left',
  TOP_RIGHT = 'top-right',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_RIGHT = 'bottom-right',
  CENTER = 'center'
}

export enum SnackbarDuration {
  SHORT = 2000,
  NORMAL = 5000,
  LONG = 8000,
  PERSISTENT = 0
}

export const defaultConfig: MatSnackBarConfig = {
  duration: SnackbarDuration.NORMAL,
  horizontalPosition: 'center',
  verticalPosition: 'bottom',
  panelClass: ['default-snackbar']
};


export class SnackbarConfig {
  static getByType(type: SnackbarType, duration?: SnackbarDuration): MatSnackBarConfig {
    const configs: Record<SnackbarType, MatSnackBarConfig> = {
      [SnackbarType.SUCCESS]: {
        duration: duration || SnackbarDuration.NORMAL,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        panelClass: ['snackbar-success']
      },
      [SnackbarType.ERROR]: {
        duration: duration || SnackbarDuration.LONG,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        panelClass: ['snackbar-error']
      },
      [SnackbarType.WARNING]: {
        duration: duration || SnackbarDuration.NORMAL,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        panelClass: ['snackbar-warning']
      },
      [SnackbarType.INFO]: {
        duration: duration || SnackbarDuration.NORMAL,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: ['snackbar-info']
      },
      [SnackbarType.NOTIFICATION]: {
        duration: duration || SnackbarDuration.SHORT,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: ['snackbar-notification']
      }
    };

    return configs[type];
  }

  static getByPosition(position: SnackbarPosition, duration?: SnackbarDuration): MatSnackBarConfig {
    const config: MatSnackBarConfig = {
      duration: duration || SnackbarDuration.NORMAL
    };

    switch (position) {
      case SnackbarPosition.TOP:
        config.horizontalPosition = 'center';
        config.verticalPosition = 'top';
        break;
      case SnackbarPosition.BOTTOM:
        config.horizontalPosition = 'center';
        config.verticalPosition = 'bottom';
        break;
      case SnackbarPosition.TOP_LEFT:
        config.horizontalPosition = 'left';
        config.verticalPosition = 'top';
        break;
      case SnackbarPosition.TOP_RIGHT:
        config.horizontalPosition = 'right';
        config.verticalPosition = 'top';
        break;
      case SnackbarPosition.BOTTOM_LEFT:
        config.horizontalPosition = 'left';
        config.verticalPosition = 'bottom';
        break;
      case SnackbarPosition.BOTTOM_RIGHT:
        config.horizontalPosition = 'right';
        config.verticalPosition = 'bottom';
        break;
      case SnackbarPosition.CENTER:
        config.horizontalPosition = 'center';
        config.verticalPosition = 'top';
        config.panelClass = ['snackbar-center'];
        break;
    }

    return config;
  }

  static combine(type: SnackbarType, position: SnackbarPosition, duration?: SnackbarDuration): MatSnackBarConfig {
    const typeConfig = this.getByType(type);
    const positionConfig = this.getByPosition(position);

    return {
      ...typeConfig,
      ...positionConfig,
      duration: duration || typeConfig.duration,
      panelClass: [...(typeConfig.panelClass || []), ...(positionConfig.panelClass || [])]
    };
  }
}
